// extracted by mini-css-extract-plugin
module.exports = {"slider":"keen-slider","arrow":"slider-arrow","dots":"slider-dots","arrowLeft":"slider-left-arrow","arrowRight":"slider-right-arrow","arrowDisabled":"slider-disabled-arrow"};